import { render, staticRenderFns } from "./PreviewPdfManual.vue?vue&type=template&id=22c61ef8&scoped=true"
import script from "./PreviewPdfManual.vue?vue&type=script&lang=js"
export * from "./PreviewPdfManual.vue?vue&type=script&lang=js"
import style0 from "./PreviewPdfManual.vue?vue&type=style&index=0&id=22c61ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c61ef8",
  null
  
)

export default component.exports